import type {ReactNode} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import {
  AgentHomePage,
  DashboardPage,
  DesignCenterPage,
  ModelSettingsPage,
  PreviewPage,
  ProductMediaPage,
  ProjectsPage,
  PublishCenterPage,
  SettingsPage,
} from './pages/StudioPages';
import AgentWorkspacePage from './pages/AgentWorkspacePage';
import {AuthProvider} from './lib/auth';
import {SiteProvider} from './lib/site-context';

function WorkspaceRoute({children}: {children: ReactNode}) {
  return <AppLayout>{children}</AppLayout>;
}

export default function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/agent" replace />} />
        <Route path="/agent" element={<WorkspaceRoute><AgentHomePage /></WorkspaceRoute>} />
        <Route path="/agent/sites/:siteId" element={<WorkspaceRoute><AgentWorkspacePage /></WorkspaceRoute>} />
        <Route path="/dashboard" element={<WorkspaceRoute><DashboardPage /></WorkspaceRoute>} />
        <Route path="/sites" element={<WorkspaceRoute><ProjectsPage /></WorkspaceRoute>} />
        <Route path="/catalog" element={<WorkspaceRoute><ProductMediaPage /></WorkspaceRoute>} />
        <Route path="/design" element={<WorkspaceRoute><DesignCenterPage /></WorkspaceRoute>} />
        <Route path="/versions" element={<WorkspaceRoute><PreviewPage /></WorkspaceRoute>} />
        <Route path="/publish" element={<WorkspaceRoute><PublishCenterPage /></WorkspaceRoute>} />
        <Route path="/settings" element={<WorkspaceRoute><SettingsPage /></WorkspaceRoute>} />
        <Route path="/settings/ai-models" element={<WorkspaceRoute><ModelSettingsPage /></WorkspaceRoute>} />
        <Route path="*" element={<Navigate to="/agent" replace />} />
        </Routes>
      </SiteProvider>
    </AuthProvider>
  );
}
